module.exports = __webpack_public_path__ + "static/media/Scared.008fb5d5.png";